import { store } from "../../../../../stateManager";
import {
  Component,
  SET_MODAL_VISIBILITY,
  SET_SNACKBAR_VISIBILITY,
} from "../../../../../stateManager/store/formCreation_v2/types";
import { getParentModal } from "./";

export const setCondElVisibility = (
  elementId: string,
  components: Component
) => {
  const component = components[elementId] || {};
  const type = component.type;

  // modal renderer
  const modal = getParentModal(elementId, components);
  if (type === "A8Modal" || type === "CustomModal" || modal) {
    const modalType = modal === null ? type : modal.type;
    store.dispatch({
      type: SET_MODAL_VISIBILITY,
      data: {
        modal: {
          visible: true,
          componentId: modal === null ? elementId : modal.id,
          isCustom: modalType === "CustomModal" ? true : false,
        },
      },
    });
  } else {
    store.dispatch({
      type: SET_MODAL_VISIBILITY,
      data: {
        modal: {
          visible: false,
          componentId: "",
        },
      },
    });
  }

  // snackbar renderer
  if (type === "SnackBar") {
    store.dispatch({
      type: SET_SNACKBAR_VISIBILITY,
      data: {
        snackbar: {
          visible: true,
          componentId: elementId,
        },
      },
    });
  } else {
    store.dispatch({
      type: SET_SNACKBAR_VISIBILITY,
      data: {
        snackbar: {
          visible: false,
          componentId: "",
        },
      },
    });
  }
};
